<template>
  <div class="container-xl pt-5">
    <h2 :class="titleClasses">
      {{ pageTitle }}
    </h2>
    <slot />
  </div>
</template>

<script>
export default {
  props: {
    pageTitle: {
      type: String,
      default: "Formulaire d'autodiagnostic municipal",
    },
    titleCssClasses: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      defaultTitleCssClasses: 'text-center text-secondary my-2 pb-5',
    }
  },
  computed: {
    titleClasses() {
      return this.titleCssClasses
        ? this.titleCssClasses
        : this.defaultTitleCssClasses
    },
  },
}
</script>

<style>
</style>
